'use client'

import { useEffect, useState } from 'react'

import { useTranslations } from 'next-intl'

export default function InstallAppPopup({ isMobileWebview }: { isMobileWebview: boolean }) {

  const [hideModal, setHideModal] = useState(false)

  function onClose() {
    const maxAge = 30 * 24 * 60 * 60
    let cookie = `${encodeURIComponent('install_app')}=${encodeURIComponent('true')}; path=/`
    if (maxAge) cookie += `; max-age=${maxAge}`
    cookie += `; SameSite=Strict; Secure`
    document.cookie = cookie
    //document.location.reload()
    setHideModal(true)
  }

  function getMobileOS() {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(ua)) {
      return 'Android'
    }

    if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    ) {
      return 'iOS'
    }

    return 'Other'
  }

  const t = useTranslations('PopupInstallApp')
  const [downloadLink, set_downloadLink] = useState(
    'https://play.google.com/store/apps/details?id=com.labulleverte.app'
  )

  useEffect(() => {
    const os = getMobileOS()
    if (os == 'iOS') {
      set_downloadLink(
        'https://apps.apple.com/fr/app/la-bulle-verte/id6746047585'
      )
    }
  })

  return (
    !hideModal && !isMobileWebview && <div className="popupShadow fixed bottom-0 left-0 right-0 z-[99] flex w-full flex-col gap-4 rounded-t-2xl bg-white p-4 small:hidden">
      <div className="flex w-full items-center justify-between">
        <p className="font-playfairDisplay-bold-italic text-xl">
          {t('openInApp')}
        </p>

        <button onClick={() => onClose()} className="text-xl" aria-label='close'>X</button>
      </div>

      <p>{t('betterExp')}</p>

      <a
        aria-label='download'
        href={downloadLink}
        onClick={onClose}
        className="flex items-center justify-center rounded-full bg-green px-8 py-2 font-bold uppercase text-white"
      >
        {t('download')}
      </a>
    </div>
  )
}
